/* eslint-disable import/prefer-default-export */
export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/dashboard/index.js